import axios from "axios";
import { API_URL } from "../config";

export interface Class {
  _id: string;
  name: string;
  description: string;
  type: "candle" | "plant";
  mainImage: string;
  gallery: {
    showcase: string[];
    studentWork: string[];
  };
  details: {
    duration: string;
    materials: string[];
    price: number;
    schedule: string;
    location: string;
  };
}

export interface PortfolioItem {
  _id: string;
  title: string;
  description: string;
  image: string;
  category: "candle" | "plant";
  createdAt: string;
}

export interface Portfolio {
  items: PortfolioItem[];
  pdf?: string;
}

export const getClasses = async (): Promise<Class[]> => {
  try {
    // Remove cache-busting timestamp to fix SEO issues
    const url = `${API_URL}/api/classes`;

    const response = await axios.get(url, {
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
      timeout: 15000, // 15 second timeout
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const joinClass = async (classId: string): Promise<void> => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Not authenticated");
  }

  const response = await axios.post(
    `${API_URL}/api/classes/${classId}/join`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (response.status !== 200) {
    throw new Error("Failed to join class");
  }
};
